import { api, getAuthHeader } from "../axiosConfig";

export async function getMapsKey() {
  return await api
    .get("/settings/mapsKey", { headers: getAuthHeader() })
    .then((res) => res.data?.key || null)
    .catch(() => null);
}
